import { z } from 'zod'

const tilausMaaraSchema = z.number().positive().int().max(99).nullable()

export const tilaustenMaaraSchema = z
  .object({
    vtjArvo: z.null(),
    ilmoitettuArvo: tilausMaaraSchema,
    virkailijaArvo: tilausMaaraSchema,
  })
  .nullable()

export const editSubjectRequestBodySchema = z.object({
  orderedAmount: tilaustenMaaraSchema,
})

export type EditSubjectRequestBodySchema = z.infer<
  typeof editSubjectRequestBodySchema
>
